import { instance } from '../constants/const'
import {
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_ALL_FAIL
} from './actionTypes'

export const getAll = () => async dispatch => {
  try {
    dispatch({ type: GET_ALL_REQUEST })

    const { data } = await instance.get(`/website`)

    dispatch({ type: GET_ALL_SUCCESS, payload: data.data })

  } catch (err) {
    dispatch({ type: GET_ALL_FAIL, payload: 'error' })
    // dispatch({ type: GET_ALL_PUBLICATION_FAIL, payload: err.response.data.errorMessage })
  }
}

export const sendMessage = async ({ message, name, email, alert }) => {
  try {
    await instance.post(`/message`, { message, name, email })
    alert.success('Message send successfully')

  } catch (err) {
    console.log('i ma here')
    alert.error("Message sending failed");
  }
}